import { gql, useMutation } from '@apollo/client';
import { useToast } from '@chakra-ui/react';
import * as React from 'react';

import { logError } from '@/imports/logging/ClientLogger';

import { usePrepareSpecificGroupMemberCsvUpload_PrepSpecificGroupMemberCsvUpload } from './graphql-types/usePrepareSpecificGroupMemberCsvUpload_PrepSpecificGroupMemberCsvUpload';

const PREP_SPECIFIC_GROUP_MEMBER_CSV_UPLOAD = gql`
  mutation usePrepareSpecificGroupMemberCsvUpload_PrepSpecificGroupMemberCsvUpload {
    prepSpecificGroupMemberCsvUpload {
      presignedS3Url
      csvUploadId
      metadataHeaders {
        name
        value
      }
    }
  }
`;

export const usePrepareSpecificGroupMemberCsvUpload = (): {
  prepSpecificGroupMemberCsvUpload: () => Promise<void>;
  prepSpecificGroupMemberCsvUploadData:
    | usePrepareSpecificGroupMemberCsvUpload_PrepSpecificGroupMemberCsvUpload
    | null
    | undefined;
  prepSpecificGroupMemberCsvUploadLoading: boolean;
  clearSpecificGroupMemberCsvUploadResult: () => void;
} => {
  const toast = useToast();

  const [
    prepSpecificGroupMemberCsvUpload,
    prepSpecificGroupMemberCsvUploadResult,
  ] =
    useMutation<usePrepareSpecificGroupMemberCsvUpload_PrepSpecificGroupMemberCsvUpload>(
      PREP_SPECIFIC_GROUP_MEMBER_CSV_UPLOAD
    );

  const [
    SpecificGroupMemberCsvUploadPrepared,
    setSpecificGroupMemberCsvUploadPrepared,
  ] = React.useState(false);

  const prepSpecificGroupMemberCsvUploadData =
    SpecificGroupMemberCsvUploadPrepared
      ? prepSpecificGroupMemberCsvUploadResult.data
      : undefined;

  React.useEffect(() => {
    if (!!prepSpecificGroupMemberCsvUploadResult.data) {
      setSpecificGroupMemberCsvUploadPrepared(true);
    }
  }, [prepSpecificGroupMemberCsvUploadResult.data]);

  const handlePrepSpecificGroupMemberCsvUpload = async (): Promise<void> => {
    try {
      await prepSpecificGroupMemberCsvUpload();
    } catch (err) {
      toast({
        title: 'Failed to prepare the csv upload. Please try again.',
        status: 'error',
      });
      logError(err);
    }
  };

  return {
    prepSpecificGroupMemberCsvUpload: handlePrepSpecificGroupMemberCsvUpload,
    prepSpecificGroupMemberCsvUploadData,
    prepSpecificGroupMemberCsvUploadLoading:
      prepSpecificGroupMemberCsvUploadResult.loading,
    clearSpecificGroupMemberCsvUploadResult: () =>
      setSpecificGroupMemberCsvUploadPrepared(false),
  };
};
